import React, { useEffect } from 'react'

import {
  Form as FormComponent,
  Grid,
  Input,
  Button,
  CurrencyInput
} from 'components'
import { useLoading, useException, useModal, useGet } from 'hooks'
import { useFormContext } from 'react-hook-form'
import { IEntityGST, IResponseTypes } from 'services/core/genericEntityGST'
import { UfirServices } from 'services/GST/GraduacaoMultas'
import { SPACING } from 'utils'

import { IForm } from '../../types'


interface IFormProps {
  refreshTable: () => void
}


interface IUfirReponse {
  idUfir: number,
  vlUnidadeUfir: number,
  txPortaria: string,
  dtCriacao: string
}

const Form: React.FC<IFormProps> = ({
  refreshTable
}) => {
  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors }
  } = useFormContext<IForm>()

  const {
    data
  } = useGet<{}, IEntityGST<IUfirReponse>>({
    api: 'Gst',
    isPaginated: false,
    params: {},
    url: 'Ufir/BuscarUltimoUfirCriado'
  })

  const setValues = () => {
    setValue('txPortaria', data?.entity?.txPortaria)
    setValue('valorUFIR', data?.entity?.vlUnidadeUfir)
  }

  if (typeof (getValues('txPortaria')) === 'undefined') {
    setValues();
  }

  const { setLoading } = useLoading()
  const { createCustomException, getException } = useException()
  const { showModal } = useModal()

  const handleSubmitForm = (form: IForm) => {
    setLoading('loading')

    UfirServices()
      .createNewValorUnidadeUFIR({
        dtCriacao: new Date(),
        txPortaria: form.txPortaria,
        vlUnidadeUFIR: form.valorUFIR
      })
      .then((response) => {
        const { detalhe, tipo, mensagem } = response?.data

        if (response.status !== 200) {
          createCustomException({
            detalhe,
            message: detalhe || mensagem || 'Ocorreu um erro ao carregar os filtros.',
            tipo: IResponseTypes[tipo]
          })
        }

        setLoading('idle')

        showModal({
          handleConfirm: () => refreshTable(),
          hideButtonCancel: true,
          message: response?.data?.mensagem || 'Dados salvos com sucesso.',
          txtButtonConfirm: 'OK',
          type: 'success'
        })
      })
      .catch((e: Error) => {
        const error = getException(e)

        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: error.message,
          txtButtonConfirm: 'OK',
          type: error.tipo || 'error'
        })
      })
  }

  return (
    <FormComponent
      onSubmit={handleSubmit(handleSubmitForm)}
      marginBottom={SPACING.spacing10}
    >
      <Grid
        gridCols="2fr 2fr 2fr 2fr 2fr 2fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <CurrencyInput
          control={control}
          errors={errors}
          label="Valor Unidade UFIR"
          formValue="valorUFIR"
          required
        />
        <Input
          control={control}
          errors={errors}
          label="Portaria"
          placeholder="Portaria"
          formValue="txPortaria"
          maxLength={50}
          required
        />
        <Button
          variantButton="default"
          text="SALVAR"
          type="submit"
          width={'max-content'}
          marginTop={SPACING.spacing10}
        />
      </Grid>
    </FormComponent>
  )
}

export default Form
